import ScormAPI from '@/lib/ScormApi/ScormAPI'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import CMIInterface from "@/lib/ScormApi/Scorm/interfaces/CMIInterface"

export default function CMI (API: ScormAPI): CMIInterface {
  const jsonString = true
  let _suspend_data = ""
  let _launch_data = ""
  let _comments = ""
  let _comments_from_lms = ""
  let core__children = 'student_id,student_name,lesson_location,credit,lesson_status,entry,score,total_time,lesson_mode,exit,session_time'
  let core__student_id = ''
  let core__student_name = ''
  let core__lesson_location = ''
  let core__credit = ''
  let core__lesson_status = ''
  let core__entry = ''
  let core__total_time = ''
  let core__lesson_mode = 'normal'
  let core__exit = ''
  let core__session_time = ''
  let score__children = 'raw,min,max'
  let score__raw = ''
  let score__min = ''
  let score__max = '100'
  let objectives__children = 'id,score,status'
  let student_data__children = 'mastery_score,max_time_allowed,time_limit_action'
  let student_data__mastery_score = ''
  let student_data__max_time_allowed = ''
  let student_data__time_limit_action = ''
  let student_preference__children = 'audio,language,speed,text'
  let student_preference__audio = ''
  let student_preference__language = ''
  let student_preference__speed = ''
  let student_preference__text = ''
  let interactions__children = 'id,objectives,time,type,correct_responses,weighting,student_response,result,latency'

  return {
    get suspend_data () {
      return _suspend_data
    },
    set suspend_data (suspend_data) {
      _suspend_data = suspend_data
    },
    get launch_data () {
      return _launch_data
    },
    set launch_data (launch_data) {
      API.isNotInitialized() ? _launch_data = launch_data : API.throwSCORMError(403)
    },
    get comments () {
      return _comments
    },
    set comments (comments) {
      _comments = comments
    },
    get comments_from_lms () {
      return _comments_from_lms
    },
    set comments_from_lms (comments_from_lms) {
      API.isNotInitialized() ? _comments_from_lms = comments_from_lms : API.throwSCORMError(403)
    },
    core: {
      get _children () {
        return core__children
      },
      set _children (_children) {
        API.throwSCORMError(402)
      },
      get student_id () {
        return core__student_id
      },
      set student_id (student_id) {
        API.isNotInitialized() ? core__student_id = student_id : API.throwSCORMError(403)
      },
      get student_name () {
        return core__student_name
      },
      set student_name (student_name) {
        API.isNotInitialized() ? core__student_name = student_name : API.throwSCORMError(403)
      },
      get lesson_location () {
        return core__lesson_location
      },
      set lesson_location (lesson_location) {
        core__lesson_location = lesson_location
      },
      get credit () {
        return core__credit
      },
      set credit (credit) {
        API.isNotInitialized() ? core__credit = credit : API.throwSCORMError(403)
      },
      get lesson_status () {
        return core__lesson_status
      },
      set lesson_status (lesson_status) {
        core__lesson_status = lesson_status
      },
      get entry () {
        return core__entry
      },
      set entry (entry) {
        API.isNotInitialized() ? core__entry = entry : API.throwSCORMError(403)
      },
      get total_time () {
        return core__total_time
      },
      set total_time (total_time) {
        API.isNotInitialized() ? core__total_time = total_time : API.throwSCORMError(403)
      },
      get lesson_mode () {
        return core__lesson_mode
      },
      set lesson_mode (lesson_mode) {
        API.isNotInitialized() ? core__lesson_mode = lesson_mode : API.throwSCORMError(403)
      },
      get exit (): any {
        return (!jsonString) ? API.throwSCORMError(404) : core__exit
      },
      set exit (exit) {
        core__exit = exit
      },
      get session_time (): any {
        return (!jsonString) ? API.throwSCORMError(404) : core__session_time
      },
      set session_time (session_time) {
        core__session_time = session_time
      },
      score: {
        get _children () {
          return score__children
        },
        set _children (_children) {
          API.throwSCORMError(402)
        },
        get raw () {
          return score__raw
        },
        set raw (raw) {
          score__raw = raw
        },
        get min () {
          return score__min
        },
        set min (min) {
          score__min = min
        },
        get max () {
          return score__max
        },
        set max (max) {
          score__max = max
        },
        toJSON: new JsonFormatter().apply
      },
      toJSON: new JsonFormatter().apply
    },
    objectives: {
      childArray: [],
      get _children () {
        return objectives__children
      },
      set _children (_children) {
        API.throwSCORMError(402)
      },
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        API.throwSCORMError(402)
      },
      toJSON: new JsonFormatter().apply
    },
    student_data: {
      get _children () {
        return student_data__children
      },
      set _children (_children) {
        API.throwSCORMError(402)
      },
      get mastery_score () {
        return student_data__mastery_score
      },
      set mastery_score (mastery_score) {
        API.isNotInitialized() ? student_data__mastery_score = mastery_score : API.throwSCORMError(403)
      },
      get max_time_allowed () {
        return student_data__max_time_allowed
      },
      set max_time_allowed (max_time_allowed) {
        API.isNotInitialized() ? student_data__max_time_allowed = max_time_allowed : API.throwSCORMError(403)
      },
      get time_limit_action () {
        return student_data__time_limit_action
      },
      set time_limit_action (time_limit_action) {
        API.isNotInitialized() ? student_data__time_limit_action = time_limit_action : API.throwSCORMError(403)
      },
      toJSON: new JsonFormatter().apply
    },
    student_preference: {
      get _children () {
        return student_preference__children
      },
      set _children (_children) {
        API.throwSCORMError(402)
      },
      get audio () {
        return student_preference__audio
      },
      set audio (audio) {
        student_preference__audio = audio
      },
      get language () {
        return student_preference__language
      },
      set language (language) {
        student_preference__language = language
      },
      get speed () {
        return student_preference__speed
      },
      set speed (speed) {
        student_preference__speed = speed
      },
      get text () {
        return student_preference__text
      },
      set text (text) {
        student_preference__text = text
      },
      toJSON: new JsonFormatter().apply
    },
    interactions: {
      childArray: [],
      get _children () {
        return interactions__children
      },
      set _children (_children) {
        API.throwSCORMError(402)
      },
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        API.throwSCORMError(402)
      },
      toJSON: new JsonFormatter().apply
    },
    toJSON: new JsonFormatter().apply
  }
}
